export const regexInn = /^\d{10}$|^\d{12}$/;
export const regexPhone = /^(?:\+7\d{10}|7\d{10}|8\d{10})$/;